const NEUTRAL_BORDER_COLOR: string = '#eeeeee';

export default function applyMessageCardStyling(cardElement: HTMLElement, cardJson: any) {
    cardElement.style.borderWidth = '1px 1px 1px 3px';
    cardElement.style.borderStyle = 'solid';

    if (cardJson.themeColor) {
        cardElement.style.borderLeftColor = normalizeHexColor(cardJson.themeColor);
    } else {
        cardElement.style.borderLeftColor = NEUTRAL_BORDER_COLOR;
        cardElement.style.borderLeftWidth = '1px';
    }

    cardElement.style.borderTopColor = NEUTRAL_BORDER_COLOR;
    cardElement.style.borderRightColor = NEUTRAL_BORDER_COLOR;
    cardElement.style.borderBottomColor = NEUTRAL_BORDER_COLOR;
}

function normalizeHexColor(hexString: string): string {
    return '#' + hexString.replace(/[^0-9A-F]/gi, '');
}
